@if (isNativeIos) {
  <!-- Native iOS container -->
  <div class="container native-ios" [class.has-ios-nav]="showIosBottomNav" [class.no-bottom-padding]="!showIosBottomNav">
    <div *ngIf="displayIpadBanner" class="ipad-banner">
      <div class="text">
        <span>{{'general.HEADS_UP' | transloco}}</span>
        <span>{{'general.USE_HEADPHONES_FOR_OPTIMAL_AUDIO' | transloco}}</span>
      </div>
    </div>
    <router-outlet></router-outlet>
    @if (showIosBottomNav) {
      <app-ios-bottom-nav></app-ios-bottom-nav>
    }
  </div>
} @else {
  <!-- Web container -->
  <div class="container">
    @if (links.length > 0) {
      <app-sb-navbar [links]="links" [isQcAdmin]="isQcAdmin"></app-sb-navbar>
    }
    <div *ngIf="displayIpadBanner" class="ipad-banner">
      <div class="text">
        <span>{{'general.HEADS_UP' | transloco}}</span>
        <span>{{'general.USE_HEADPHONES_FOR_OPTIMAL_AUDIO' | transloco}}</span>
      </div>
    </div>
    <router-outlet></router-outlet>
  </div>
}
